import { render, staticRenderFns } from "./NoContentView.vue?vue&type=template&id=7cb1d6e6&scoped=true"
import script from "./NoContentView.vue?vue&type=script&lang=js"
export * from "./NoContentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb1d6e6",
  null
  
)

export default component.exports